import { HttpResponse } from "@angular/common/http";
import {
  Component,
  HostListener,
  Inject,
  OnInit,
  ViewChild,
} from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatSnackBar } from "@angular/material";
import { Router } from "@angular/router";
import { AuthService } from "../auth.service";

@Component({
  selector: "app-signup",
  templateUrl: "./signup.component.html",
  styleUrls: ["./signup.component.scss"],
})
export class SignupComponent implements OnInit {
  @ViewChild("ngOtpInput") ngOtpInputRef: any;
  signupForm: FormGroup;
  isLoading: boolean = false;
  isSignUpScreen: boolean = true;
  disclaimer: boolean = false;
  choirId: any = "";
  emailPattern =
    /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/;
  imagee = "../../../assets/images/Rectangle.png";
  windowWidth: any;
  isOtpScreen: boolean = false;
  @HostListener("window:resize", ["$event"])
  onResize(event) {
    this.windowWidth = event.target.innerWidth;
  }
  constructor(
    private fb: FormBuilder,
    private authServices: AuthService,
    private _snackBar: MatSnackBar,
    private router: Router
  ) {}

  ngOnInit() {
    // this.getCountryData();
    // this.disclaimer = false;
    // this.windowWidth = window.innerWidth;
    // console.log("1",this.windowWidth)
    this.initialiseForms();
    this.choirId = localStorage.getItem("choirId");
    //  localStorage.clear();
  }

  toggle(event) {
    // console.log(event,"1111")
    this.disclaimer = event.checked;
    // console.log(this.disclaimer,"2222")
  }

  countryList = [];
  getCountryData() {
    let query = "";
    this.authServices.getCountryApi(query).subscribe(
      (res) => {
        this.isLoading = false;
        if (res["message"] == "Success") {
          this.countryList = res.data.response;
        }
      },
      (err) => {
        this.isLoading = false;
      }
    );
  }

  initialiseForms() {
    this.signupForm = this.fb.group(
      {
        email: [
          "",
          [Validators.required, Validators.pattern(this.emailPattern)],
        ],
        password: ["", [Validators.required, Validators.minLength(8)]],
      }

      // {
      //   validator: ConfirmedValidator("password", "confirmPassword"),
      // }
    );
  }

  get f() {
    return this.signupForm.controls;
  }

  signUp() {
    if (this.signupForm.valid) {
      this.verifyEmail();
    }
  }

  verifyEmail() {
    if (this.signupForm.valid) {
      let req = {
        email: this.signupForm.controls["email"].value.trim(),
      };
      this.isLoading = true;
      this.authServices.validateEmailApi(req).subscribe(
        (res: HttpResponse<any>) => {
          this.isLoading = false;

          if (res["message"] == "Success") {
            this.createOtp();
            this.isOtpScreen = true;
          } else {
            return this._snackBar.open("Email already registered!", "", {
              duration: 3000,
              horizontalPosition: "right",
              verticalPosition: "top",
              panelClass: ["success"],
            });
          }
        },
        (err) => {
          this.isLoading = false;
        }
      );
    }
  }

  otpSent: boolean = false;
  showOtpComponent: boolean = true;
  createOtp() {
    this.showOtpComponent = false;
    this.otpToken = null;
    setTimeout(() => {
      this.showOtpComponent = true;
    }, 0);
    // console.log(this.otpToken,"TTTT")
    // console.log("test create otp");
    let req = {
      email: this.signupForm.controls.email.value.toLowerCase(),
      type: "UR",
    };
    // console.log(req);
    this.isLoading = true;

    this.authServices.otpcreateApi(req).subscribe(
      (res) => {
        this.isLoading = false;
        if (res["message"] == "Success") {
          this._snackBar.open("OTP sent to your email!", "", {
            duration: 5000,
            horizontalPosition: "right",
            verticalPosition: "top",
            panelClass: ["success"],
          });
        } else {
        }
        this.isLoading = false;
        //this.getChildList();
      },
      (err) => {
        this.isLoading = false;
      }
    );
  }

  verifiedotpToken: any;
  otpScreen() {
    this.isOtpScreen = true;
    this.createOtp();
  }
  verifyOtp() {
    let request = {
      email: this.signupForm.controls.email.value.toLowerCase(),
      type: "UR",
      otp: parseInt(this.otpToken),
    };

    // console.log(request);
    this.isLoading = true;
    this.authServices.verifyOtpApi(request).subscribe(
      (res) => {
        this.isLoading = false;
        if (res["message"] == "Success") {
          this.verifiedotpToken = res["data"]["token"];
          // console.log(this.otpToken);
          // this.getVendorProfile();
          this._snackBar.open("OTP verified!", "", {
            duration: 5000,
            horizontalPosition: "right",
            verticalPosition: "top",
            panelClass: ["success"],
          });

          this.submitForm();
        } else {
        }
        this.isLoading = false;
      },
      (err) => {
        this.isLoading = false;
      }
    );
  }

  submitForm() {
    // console.log(this.otpToken,"ssssssss")
    this.isLoading = true;
    this.signupForm.markAllAsTouched();
    // for (let el in this.signupForm.controls) {
    //   if (this.signupForm.controls[el].errors) {
    //     // console.log(el,"wwwwwwww")
    //   }
    // }
    let req = this.signupForm.value;
    req["otpToken"] = this.verifiedotpToken;
    this.authServices.createAccountApi(req).subscribe(
      (res: HttpResponse<any>) => {
        this.isLoading = false;
        if (res["message"] == "Success") {
          // this._snackBar.open("Account created successfully!", "", {
          //   duration: 3000,
          //   horizontalPosition: "right",
          //   verticalPosition: "top",
          //   panelClass: ["success"],
          // });

          localStorage.setItem("token", res["data"].accessToken);
          localStorage.setItem("userData", JSON.stringify(res["data"]));
          localStorage.setItem("activeIndex", "0");
          if (this.choirId != "") {
            this.router.navigate(["auth/login"], {
              queryParams: { choirId: this.choirId },
            });
          } else {
            this.router.navigate(["auth/login"]);
          }
        }
      },

      (err) => {
        this.isLoading = false;
      }
    );
  }

  otpToken: string;
  onOtpChange(event) {
    this.otpToken = event;
  }

  show: boolean = false;
  password() {
    this.show = !this.show;
  }

  showConfirm: boolean = false;
  passwordConfirm() {
    this.showConfirm = !this.showConfirm;
  }
  onlyNumberKey(event) {
    return event.charCode == 8 || event.charCode == 0
      ? null
      : event.charCode >= 46 && event.charCode <= 57;
  }

  screenChange() {
    this.isSignUpScreen = true;
    this.disclaimer = true;
  }
  passwordVisible = false;

  togglePasswordVisibility() {
    this.passwordVisible = !this.passwordVisible;
  }
  back() {
    window.open("https://acc-dev.abrohn.com/", "_self");
  }
}

export function ConfirmedValidator(
  controlName: string,
  matchingControlName: string
) {
  return (formGroup: FormGroup) => {
    const control = formGroup.controls[controlName];
    const matchingControl = formGroup.controls[matchingControlName];
    if (matchingControl.errors && !matchingControl.errors.confirmedValidator) {
      return;
    }
    if (control.value !== matchingControl.value) {
      matchingControl.setErrors({ confirmedValidator: true });
    } else {
      matchingControl.setErrors(null);
    }
  };
}
